import { Injectable, inject } from '@angular/core';
import { Router, UrlSerializer } from '@angular/router';

import { MatDialog } from '@angular/material/dialog';

import { Observable, of } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';

import { ExperienceService } from '@app/core/services';
import { EnvironmentData } from '@common/data';

import { DonateComponent } from '../components';


@Injectable()
export class DonateService {
  private _router = inject(Router);
  private _dialog = inject(MatDialog);
  private _experienceService = inject(ExperienceService);
  private _serializer = inject(UrlSerializer);
  private _environmentData = inject(EnvironmentData);


  // options.loaded fires once the organizations load resolves — the moment the
  // flow either opens the Donate dialog or proceeds directly (single org).
  // Callers use it to clear their button busy state (TU-T9150); a load failure
  // errors the returned observable instead.
  public donate(options: { loaded?: () => void } = {}): Observable<any> {
    return this._environmentData.gets()
      .pipe(
        tap(() => options.loaded?.()),
        switchMap((organizations) => {
          if (organizations.length > 1) {
            return this._dialog
              .open(DonateComponent, {
                data: {},
              })
              .afterClosed()
              .pipe(
                filter((response) => !!response),
              );
          }

          return of(organizations[0]);
        }),
        filter((response) => !!response),
        tap((response) => {
          const urlTree = ['/donation', response.donationGuid];
          if (this._experienceService.isExperienceParent) {
            const tree = this._router.createUrlTree(urlTree, { queryParams: {} });
            window.open(this._serializer.serialize(tree), '_blank').focus();
          } else {
            this._router.navigate(urlTree);
          }

          return response;
        }),
      );
  }

}
